import React, { FC, memo } from 'react';
import { Select as AntdSelect } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { DefaultOptionType } from 'rc-select/lib/Select';
import { ReactComponent as RightArrow } from 'shared/assets/icons/newIcons/RightArrow.svg';
import s from './index.module.scss';
import classNames from 'classnames';

type SelectSize = 'extraSmall' | SizeType;

interface SelectProps {
  options: DefaultOptionType[];
  onChange?: (value: string, option: DefaultOptionType | DefaultOptionType[]) => void;
  label?: string;
  placeholder?: string;
  size?: SelectSize;
  value?: Nullable<string>;
  defaultValue?: Nullable<string>;
  className?: string;
  containerClassName?: string;
  bordered?: boolean;
  disabled?: boolean;
  requiredMark?: boolean;
  allowClear?: boolean;
  onClear?: () => void;
  showSuffixIcon?: boolean;
  popupMatchSelectWidth?: boolean;
  // Controls root background color class
  background?: 'white' | 'background' | 'transparent';
  // Reduces internal paddings (overrides module selector paddings)
  compact?: boolean;
}

export const Select: FC<SelectProps> = memo((props) => {
  const {
    size = 'middle',
    options,
    placeholder,
    onChange,
    value,
    defaultValue,
    className,
    disabled,
    bordered = false,
    requiredMark,
    containerClassName,
    label,
    allowClear,
    onClear,
    showSuffixIcon = true,
    popupMatchSelectWidth = true,
    background = 'white',
    compact = false,
  } = props;

  return (
    <div className={classNames('relative', containerClassName)}>
      {label && <div className="mb-2">{label}</div>}
      {requiredMark && <div className="text-error text-2xl absolute z-10 top-0 left-1 pointer-events-none">*</div>}
      <AntdSelect
        options={options}
        placeholder={placeholder}
        onChange={onChange}
        value={value || undefined}
        defaultValue={defaultValue}
        optionLabelProp="label"
        className={classNames(s.select, s[size], className, {
          [s.bgBackground]: background === 'background',
          [s.bgTransparent]: background === 'transparent',
          [s.compact]: compact,
        })}
        variant={bordered ? 'outlined' : 'borderless'}
        disabled={disabled}
        allowClear={allowClear}
        onClear={onClear}
        suffixIcon={showSuffixIcon ? <RightArrow className="text-grey w-[13px] h-[13px] rotate-90" /> : null}
        popupMatchSelectWidth={popupMatchSelectWidth}
      />
    </div>
  );
});
